import styled from "styled-components";

export const SuggestedVideoSlidesFilterItemPreviewFooterTextDefaultBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    color: ${({theme}) => theme.colors.textLight};
    text-transform: uppercase;
    letter-spacing: 0.1rem;
    ${({theme}) => theme.font.presets.bold};
`;